import { Flex, Link, SlideFade } from '@chakra-ui/react'
import React from 'react'
import { MangoAlert } from '~/components/shared/MangoAlert'
import { useAnalytics } from '~/hooks/useAnalytics'
import { NotificationDisposition } from '~/services/EventEmitter/types/NotificationEmitterTypes'
import { AnalyticsNamespace, ContactsAnalyticsEvents } from '~/types/Analytics'

const ADVERT_DESTINATION = 'https://mangovoice.com/mango-contact-sync/'

export const ContactsAdvertisementPanel = () => {
  const { track } = useAnalytics(AnalyticsNamespace.CONTACTS)

  const handleLinkClicked = () => {
    track(ContactsAnalyticsEvents.ContactsAdvertLinkClicked)
    window.open(ADVERT_DESTINATION, '_blank')
  }

  return (
    <SlideFade in={true} offsetY="-20px" unmountOnExit>
      <Flex
        px="1rem"
        pt="1rem"
        justifyContent="center"
        alignItems="center"
        gap="1.25rem"
        alignSelf="stretch"
        cursor="pointer"
        onClick={handleLinkClicked}
      >
        <MangoAlert
          alignSelf="stretch"
          status={NotificationDisposition.Info}
          boxShadow="none"
          description={
            <>
              NEW: Auto-sync your contacts with Mango.{' '}
              <Link
                isExternal
                color="white"
                textDecoration="underline"
                textUnderlineOffset="0.25rem"
                onClick={handleLinkClicked}
              >
                Learn More
              </Link>
            </>
          }
        ></MangoAlert>
      </Flex>
    </SlideFade>
  )
}
